import React, { useEffect, useMemo, useState } from 'react';
import GameLayout from './GameLayout';
import './TicTacToeGame.css';

import partyBomb from './partyBomb';

const LINES = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8],
  [0, 4, 8],
  [2, 4, 6],
];

function winner(board) {
  for (const [a, b, c] of LINES) {
    if (board[a] && board[a] === board[b] && board[a] === board[c]) return board[a];
  }
  return null;
}

function bestMove(board) {
  // Simple: win if possible, block if needed, else center, else random.
  const empty = board.map((v, i) => (v ? null : i)).filter((v) => v !== null);
  const tryLine = (mark) => {
    for (const [a, b, c] of LINES) {
      const vals = [board[a], board[b], board[c]];
      if (vals.filter((v) => v === mark).length === 2 && vals.includes(null)) {
        const idx = [a, b, c][vals.indexOf(null)];
        return idx;
      }
    }
    return null;
  };

  return (
    tryLine('O') ??
    tryLine('X') ??
    (board[4] === null ? 4 : null) ??
    empty[Math.floor(Math.random() * empty.length)] ??
    null
  );
}

export default function TicTacToeGame() {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [turn, setTurn] = useState('X'); // X=user, O=bot
  const [status, setStatus] = useState('Your turn');

  const win = useMemo(() => winner(board), [board]);
  const full = board.every(Boolean);

  const reset = () => {
    setBoard(Array(9).fill(null));
    setTurn('X');
    setStatus('Your turn');
  };

  const playAt = (i) => {
    if (board[i] || win || full) return;
    if (turn !== 'X') return;

    const next = board.slice();
    next[i] = 'X';
    setBoard(next);

    const w1 = winner(next);
    if (w1) {
      setStatus('You win!');
      return;
    }
    if (next.every(Boolean)) {
      setStatus('Draw');
      return;
    }

    setTurn('O');
    setStatus('Bot thinking…');

    setTimeout(() => {
      const b2 = next.slice();
      const move = bestMove(b2);
      if (move === null) return;
      b2[move] = 'O';
      setBoard(b2);

      const w2 = winner(b2);
      if (w2) {
        setStatus('Bot wins');
      } else if (b2.every(Boolean)) {
        setStatus('Draw');
      } else {
        setTurn('X');
        setStatus('Your turn');
      }
    }, 320);
  };

  useEffect(() => {
    // Celebrate game completion (win or draw)
    if (status === 'You win!' || status === 'Draw') partyBomb();
  }, [status]);

  return (
    <GameLayout title="Tic-Tac-Toe" subtitle="Play vs bot. Quick round." rightSlot={<button className="ttt-reset" onClick={reset}>Reset</button>}>
      <div className="ttt-wrap">
        <div className="ttt-status">{status}</div>
        <div className="ttt-grid" role="grid" aria-label="Tic tac toe grid">
          {board.map((v, i) => (
            <button key={i} className="ttt-cell" onClick={() => playAt(i)}>
              {v}
            </button>
          ))}
        </div>
      </div>
    </GameLayout>
  );
}
